// Module for a flight result ui component

'use strict'
import $ from 'jquery';
import * as fmt from '../util/formats.js';
import { FlightSummary, FlightDetails } from './index.js';

class Result {

    constructor(id, tripOption, xIcon, data) {
        this.id = id;   //tripOption index
        this.data = data;
        this.tripOption = tripOption;   //not array, tripOption[id] object
        this.xIcon = xIcon;
        //this.isRoundTrip = $('.btn-chosen').text() === "Round Trip" ? true : false; //always false for demo
        this.isRoundTrip = (this.tripOption.slice.length == 2);
        //console.log(this.isRoundTrip);
		const segmentEndIndex = this.tripOption.slice[0].segment.length - 1;  //the last index of the segment
		this.origin = this.tripOption.slice[0].segment[0].leg[0].origin; 
		this.dest = this.tripOption.slice[0].segment[segmentEndIndex].leg[0].destination;
		this.layovers = this.tripOption.slice[0].segment.length - 1;
        this.departure = fmt.formatTime(this.tripOption.slice[0].segment[0].leg[0].departureTime);
        this.arrival = fmt.formatTime(this.tripOption.slice[0].segment[0].leg[0].arrivalTime);

        this.flightSection = this.flightSection.bind(this);
    }

    // Create the flights section of the tab 
    flightSection() {
        let inboundParams = {};

        const outboundParams = [
            'out',
            this.origin,
            this.dest,
            this.departure,
            this.arrival,
            this.layovers
        ];

		// Create the flight summary for the return flight for round trips
		if(this.isRoundTrip) {
			let returnDeparture = this.tripOption.slice[1].segment[0].leg[0].departureTime;
			returnDeparture = fmt.formatTime(returnDeparture);

			const sliceSize = this.tripOption.slice.length - 1;
			const returnLayovers = this.tripOption.slice[sliceSize].segment.length - 1;

            let returnArrival = null;
            if(this.tripOption.slice[1].segment[returnLayovers]) {
				returnArrival = this.tripOption.slice[1].segment[returnLayovers].leg[0].arrivalTime;
				returnArrival = fmt.formatTime(returnArrival);
            }

            inboundParams = [
                'in',
                this.dest,
                this.origin,
                returnDeparture,
                returnArrival,
                returnLayovers
            ];

            return `
                <div class='flight-container' style='padding-top:${this.isRoundTrip ? '0rem' : '1rem'}'>
                    ${FlightSummary(...outboundParams)}
                    <hr> ${FlightSummary(...inboundParams)}
                </div>
            `;

		}

        //one way
        return `
            <div class='flight-container' style='padding-top:${this.isRoundTrip ? '0rem' : '1rem'}'>
                ${FlightSummary(...outboundParams)}
            </div>
        `;
    }

    logoSection(slice) {
        const initCarrier = slice[0].segment[0].flight.carrier;
        let isMultiCarrier = false;
        for (let i = 0; i < slice.length; i++)
        {
            const segment = slice[i].segment;
            for (let j = 0; j < segment.length; j++)
            {
                if (segment[j].flight.carrier != initCarrier)
                {
                    isMultiCarrier = true;
                    return `
                        <div class="logo-container">
                            <img src="https://www.gstatic.com/flights/airline_logos/70px/multi.png" 
                                style="border: 0; width: 70px; margin-right:30px">
                        </div>
                    `;
                }
            }
        }
        const carrierCode = slice[0].segment[0].flight.carrier;
        return `
            <div class="logo-container">
                <img src="https://pics.avs.io/300/100/${carrierCode}@2x.png" 
                    style="border: 0; width: 100px;">
            </div>
        `;
    }

    // Create the left section of the tab containing the price and carbon
    textSection(type) {
        const id = `${type}-container-${this.id}`;
        let save = '';
        let price = '';
        if(type === 'price') {
            price = this.tripOption.pricing[0].saleTotal;
            price = fmt.formatCurrency(JSON.stringify(price).replace(/[\\"]/g, ''));
            save = `<button class='save-btn'>Add to Footprint</button><div class='save-message' id='save-message-${this.id}'></div>`;
            //save = `<button class='save-btn'>save</button>`
        }

        // const colors = ['#EB3A43', '#F56D00', '#01A651'];
        //         style='color: ${type === 'carbon' ? colors[Math.floor(Math.random()*3)] : ''}'>

        return `
            <div id='${id}' class='${type}-container'>
                ${price}
            </div>
            ${save}
        `;
    }

    detailSection() {
        const outbound = new FlightDetails(this.id, this.tripOption.slice[0], 'out', this.data);
        const outboundHTML = outbound.getFlightDetails();
        if(this.isRoundTrip) {
            var inbound = new FlightDetails(this.id, this.tripOption.slice[1], 'in', this.data);
            var inboundHTML = inbound.getFlightDetails();
        }

        return `
            <div id='result-details-${this.id}' class='details-container'>
                ${outboundHTML}
                ${this.isRoundTrip ? inboundHTML : ''}
            </div>
        `;
    }

    getResult() {
        const tabWidth = window.global.constants.tabWidth;
        const tabHeight = window.global.constants.tabHeight;
        const slice = this.tripOption.slice;

        let resultContainer = document.createElement('div');
        let result = document.createElement('div');
        let initialContainer = document.createElement('div');
        initialContainer.className = 'initial-result-container';
        result.id = `result-${this.id}`;
        result.className = 'result-tab';
        result.collapsed = '2';
        result.style.width = window.global.constants.tabWidth + 'px';
        result.style.height = window.global.constants.tabHeight + 'px';

		initialContainer.insertAdjacentHTML('beforeend', this.logoSection(slice));
		initialContainer.insertAdjacentHTML('beforeend', this.textSection('carbon'));
		initialContainer.insertAdjacentHTML('beforeend', this.flightSection());
		initialContainer.insertAdjacentHTML('beforeend', this.textSection('price'));
		result.appendChild(this.xIcon);
        result.appendChild(initialContainer);
		result.insertAdjacentHTML('beforeend', this.detailSection());

		result.isOpen = false;
        resultContainer.style.overflow = 'hidden';
        resultContainer.appendChild(result);

        return resultContainer;

        // let resultContainer = document.createElement('div');
        // let result = document.createElement('div');
        // let initialContainer = document.createElement('div');
        // initialContainer.className = 'initial-result-container';
        // result.id = `result-${this.id}`;
        // result.className = 'result-tab';
        // result.collapsed = '2';
        // result.style.width = window.global.constants.tabWidth + 'px';
        // result.style.height = window.global.constants.tabHeight + 'px';
		// initialContainer.appendChild(LogoSection(iata));
		// initialContainer.appendChild(this.leftSection());
		// initialContainer.appendChild(this.flightSection());
        // result.appendChild(initialContainer);
		// result.appendChild(this.xIcon);
		// result.appendChild(this.detailSection());
		// result.isOpen = false;
        // resultContainer.style.overflow = 'hidden';
        // resultContainer.appendChild(result);
        // return resultContainer;

        // return `
        //     <div style='overflow: hidden;'>
        //         <div id='result-${this.id}'
        //             class='result-tab'
        //             data-isopen='false'
        //             data-collapsed='2' 
        //             style='width: ${tabWidth}px; height: ${tabHeight}px;'>
        //             ${this.xIcon} <!-- ALKSJFALKJF -->
        //             <div class='initial-result-container'>
        //                 ${this.logoSection(iata)}
        //                 ${this.textSection('price')}
        //                 ${this.flightSection()}
        //                 ${this.textSection('carbon')}
        //             </div>
        //             ${this.detailSection()}
        //         </div>
        //     </div>
        // `;

    }
}

export default Result



// WEBPACK FOOTER //
// ./components/Result.js